import axios from "axios";
import { IDM_SERVER_BASE_URL } from "../Constants";
import { COOKIES, SEPERATOR } from "./AuthenticationService";

export const API_URL = IDM_SERVER_BASE_URL + "/api";

class DeviceService {
    GetDevices = async () => {
        const response = await axios.get(`${API_URL}/DeviceInfo`);

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    };

    GetDevicesPerPage = async (deviceSearchDTO) => {
        var request = {
            request: deviceSearchDTO,
        };
        const response = await axios.post(`${API_URL}/DeviceSearch`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    }

    GetDeviceModelsPerPage = async (deviceSearchDTO) => {
        var request = {
            request: deviceSearchDTO,
        };
        const response = await axios.post(`${API_URL}/DeviceModelSearch`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.data.response == null) {
            throw new Error(response.data.errors?.[0]?.message || "Request failed.");
        }

        return response.data.response;
    }

    GetDevice = async (DeviceId) => {
        const response = await axios.get(`${API_URL}/DeviceDetail/${DeviceId}`);

        return response.data;
    };

    ActivateDeactivateDevice = async (serialNum, isActive) => {
        let queryString = `?isActive=${isActive}`
        if (serialNum != null) {
            const Buffer = require("buffer").Buffer;
            let encodedSerialNo = new Buffer(serialNum).toString("base64");
            queryString = `${queryString}&encodedSerialNo=${encodedSerialNo}`;
        }
        const response = await axios.patch(
            `${API_URL}/DeviceDetail${queryString}`
        );

        return response.data;
    };

    ForceCertificateRotation = async (serialNum) => {
        const Buffer = require("buffer").Buffer;
        let encodedSerialNo = new Buffer(serialNum).toString("base64");
        const response = await axios.patch(
            `${API_URL}/ForceCertificateRotation?encodedSerialNo=${encodedSerialNo}`
        );

        return response.data;
    };

    CreateDeviceDetail = async (DeviceDetailDTO) => {
        var request = {
            request: DeviceDetailDTO,
        };
        const response = await axios.post(
            `${API_URL}/DeviceDetail`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };

    UpdateDeviceDetail = async (deviceId, DeviceDetailDTO) => {
        const request = {
            request: DeviceDetailDTO,
        };
        const response = await axios.put(
            `${API_URL}/DeviceDetail/${deviceId}`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    DeleteDeviceDetail = async (id) => {
        const response = await axios.delete(
            `${API_URL}/DeviceDetail/${id}`
        );
    };

    GetDeviceModels = async () => {
        const response = await axios.get(`${API_URL}/DeviceModel`);

        return response.data;
    };

    GetDeviceModel = async (DeviceModelId) => {
        const response = await axios.get(`${API_URL}/DeviceModel/${DeviceModelId}`);

        return response.data;
    };

    CreateDeviceModel = async (DeviceModelDTO) => {
        const request = {
            request: DeviceModelDTO,
        };
        const response = await axios.post(
            `${API_URL}/DeviceModel`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    UpdateDeviceModel = async (DeviceModelId, DeviceModelDTO) => {
        const request = {
            request: DeviceModelDTO,
        };
        const response = await axios.put(
            `${API_URL}/DeviceModel/${DeviceModelId}`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    };

    GetDeviceInfo = async () => {
        const response = await axios.get(`${API_URL}/DeviceInfo`);

        return response.data;
    }

    BulkDeleteDeviceDetails = async (DeviceIds) => {
        var request = {
            request: DeviceIds,
        };
        const response = await axios.post(
            `${API_URL}/BulkDeviceDetailDelete`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };

    BulkDeleteDeviceModels = async (DeviceModelIds) => {
        var request = {
            request: DeviceModelIds,
        }; 
        const response = await axios.post(
            `${API_URL}/BulkDeviceModelDelete`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };

    BulkEditDeviceDetails = async (Devices) => {
        var request = {
            request: Devices,
        };
        const response = await axios.post(
            `${API_URL}/BulkActivateDeactivateDevices`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };

    UploadDevices = async (Devices) => {
        var request = {
            request: Devices,
        };        
        const response = await axios.post(
            `${API_URL}/BulkDeviceDetailUpload`,
            request,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    };
}

export default new DeviceService();
